import { Pipe, PipeTransform } from '@angular/core';
import { TranslationHelper } from '@core/helpers';
import { Store } from '@ngrx/store';
import { selectLanguageTranslations } from '@store/selectors';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Pipe({
  name: 'translate',
  pure: false
})
export class TranslatePipe implements PipeTransform {
  constructor(
    private store: Store,
    private translationHelper: TranslationHelper
  ) {}

  transform(key: string): Observable<string> {
    return this.store.select(selectLanguageTranslations).pipe(
      map(() => this.translationHelper.getTranslate(key))
    );
  }
}